<template>
    <div>
      <user-details-form v-if="profile" :profile="profile" :organization="organization" :accreditation="accreditation" :signatures="signatures"></user-details-form>
      <div class="toggle-preload preload-active" v-if="loading">
        <img src="@/assets/img/static/rolling.gif" alt="">
      </div>
    </div>
</template>

<script>
  import UserDetailsForm from './UserDetailsForm';

  export default {
    name: "UserDetails",

    components: {
      UserDetailsForm
    },

    data: () => ({
      loading: false
    }),

    computed: {
      breadcrumbs() {
        return _.get(this.profile, 'lastName');
      },

      userId() {
        return +this.$route.params.userId;
      },

      organization() {
        return this.$store.getters.organization(this.profile.organizationId);
      },

      accreditation() {
        return this.$store.getters.accreditation(this.profile.accreditationId)
      },

      profile() {
        return this.$store.getters.user(this.userId);
      },

      signatures() {
        return this.profile.signatures;
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchUser', { userId: this.userId });
        }
        catch(e) {
          console.error('unable to fetch user profile', e);
          this.globalErrorHandler(e);
        }
      });
    }
  }
</script>

<style scoped>

</style>
